import { type KeyArgsFunction, type KeySpecifier } from "@apollo/client/cache/inmemory/policies"
import { allKeyArgs } from "src/shared/initializers/typePolicies/helpers/allKeyArgs"

/**
 * Excludes pagination and volatile viewKey freshness fields from listActionItems cache keys.
 *
 * Mutations bump viewKey.mutationVersion, and checklist refetches intentionally
 * send the fresh viewKey to the server. Keeping that freshness token out of the
 * Apollo key lets the latest response replace the existing logical checklist
 * entry instead of creating one cache entry per mutation. Stable viewKey scope
 * fields must remain keyed so checklist data is not shared across legal entities
 * or view types.
 */
const STABLE_VIEW_KEY_ARGS: KeySpecifier = ["viewKey", ["legalEntityId", "viewType"]]

export const listActionItemsKeyArgs: KeyArgsFunction = (args, context) => {
  if (!args) return context.fieldName

  return [...STABLE_VIEW_KEY_ARGS, ...allKeyArgs(args, ["pagination", "page", "viewKey"])]
}
